import { StatusData } from "./data/model"

export type BundleActionTypes =
    | { type: "GET_STATUS_DATA_LOADED"; payload: { statusData: StatusData; vin: string } }
    | { type: "GET_STATUS_LOADING" }
    | { type: "GET_STATUS_DATA_ERROR" }

export const BundleActions = {}
export type IBundleActions = typeof BundleActions
